var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconButtonSaveInverted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8787 3.12868L14.8713 5.12132L13.8107 6.18198L11.818 4.18934C11.5367 3.90803 11.1552 3.75 10.7574 3.75H5.25C4.42157 3.75 3.75 4.42157 3.75 5.25V12.75C3.75 13.5784 4.42157 14.25 5.25 14.25H12.75C13.5784 14.25 14.25 13.5784 14.25 12.75V7.24264C14.25 6.84482 14.092 6.46328 13.8107 6.18198L14.8713 5.12132C15.4339 5.68393 15.75 6.44699 15.75 7.24264V12.75C15.75 14.4069 14.4069 15.75 12.75 15.75H5.25C3.59315 15.75 2.25 14.4069 2.25 12.75V5.25C2.25 3.59315 3.59315 2.25 5.25 2.25H10.7574C11.553 2.25 12.3161 2.56607 12.8787 3.12868Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 3.75H7.5V6H10.5V3.75ZM7.5 2.25C6.67157 2.25 6 2.92157 6 3.75V6C6 6.82843 6.67157 7.5 7.5 7.5H10.5C11.3284 7.5 12 6.82843 12 6V3.75C12 2.92157 11.3284 2.25 10.5 2.25H7.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 10.5H6.75V14.25H11.25V10.5ZM6.75 9C5.92157 9 5.25 9.67157 5.25 10.5L5.25 14.25C5.25 15.0784 5.92157 15.75 6.75 15.75H11.25C12.0784 15.75 12.75 15.0784 12.75 14.25V10.5C12.75 9.67157 12.0784 9 11.25 9H6.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconButtonSaveInverted);
export default __webpack_public_path__ + "static/media/icon_button_save_inverted.960eefb72889c5fb9ff277ed243eb519.svg";
export { ForwardRef as ReactComponent };